import { useContext } from 'react';

import {
  GET_HISTORY_DEVICE,
  GET_HISTORY_DEVICE_ERROR,
  GET_HISTORY_DEVICE_SUCCESS,
  GET_HISTORY_DEVICE_EXCEL,
  GET_HISTORY_DEVICE_EXCEL_SUCCESS,
  GET_HISTORY_DEVICE_EXCEL_ERROR,
} from '../../constants/historyDevice';
import { StoreContext } from '../../context/Provider';
import useApi from '../../services/request.service';
import { ToastComponent } from '../../components/ToastComponent';
import { locationPermissionService } from '../../services/locationPermissionService';
import { ICoordinates } from '../../utils/utils';

export const useHistoryDevice = () => {
  const { historyDeviceState, historyDeviceToExcelStateContext } =
    useContext(StoreContext);

  const { genericApiCallApiBilling } = useApi();

  const getHistoryDevice = async (query: string) => {
    const currentStatus = locationPermissionService.getPermissionStatus();
    if (currentStatus !== 'granted') {
      ToastComponent(
        'warning',
        'Error',
        'Por favor activa la ubicación para continuar.',
        6000
      );
      return;
    }

    let coords: ICoordinates =
      await locationPermissionService.getCurrentCoordinates();
    const dispatch = historyDeviceState.dispatch;
    dispatch({ type: GET_HISTORY_DEVICE });
    try {
      const urlQuery: string = `v1.0/histories/devices${query}`;
      const result: any = await genericApiCallApiBilling(
        urlQuery,
        'GET',
        {},
        {},
        {
          appId: 'web',
          locationGPS: `${coords?.latitude}, ${coords?.longitude}`,
        }
      );

      if (result.status === 200) {
        const payload = result.data;
        dispatch({ type: GET_HISTORY_DEVICE_SUCCESS, payload: payload });
      }
      return result;
    } catch (error: any) {
      ToastComponent(
        'warning',
        'Error',
        'La operación falló, inténtelo más tarde por favor.'
      );
      dispatch({ type: GET_HISTORY_DEVICE_ERROR, payload: error.message });
      return 'error';
    }
  };

  function downloadCSV(data: any, filename = 'Historial de dispositivo.csv') {
    const blob = new Blob(['\uFEFF' + data], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  const historyDeviceExcel = async (query: string) => {
    const dispatch = historyDeviceToExcelStateContext.dispatch;
    dispatch({ type: GET_HISTORY_DEVICE_EXCEL });
    try {
      const urlQuery = `v1.0/histories/devices/export${query}`;
      const result: any = await genericApiCallApiBilling(
        urlQuery,
        'GET',
        {},
        {},
        {}
      );
      const payload = result.data;
      if (result.status === 200) {
        dispatch({
          type: GET_HISTORY_DEVICE_EXCEL_SUCCESS,
          payload: payload,
        });
        if (payload !== null && payload !== undefined) {
          downloadCSV(payload);
        } else if (payload === '') {
          ToastComponent('warning', 'Error', 'No hay datos para excel.', 6000);
        } else {
          ToastComponent(
            'warning',
            'Error',
            'Hay un problema en la solicitud.',
            6000
          );
        }
      }
    } catch (error: any) {
      ToastComponent('warning', 'Error', error.message, 6000);
      dispatch({
        type: GET_HISTORY_DEVICE_EXCEL_ERROR,
      });
    }
  };

  return {
    getHistoryDevice,
    historyDeviceExcel,
  };
};
